import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import getMediaQuery from "css/breakpoints"
import { buttonText } from "css/buttons"
import { fullGrid } from "css/grid"
import { Heading as HeadingCN } from "css/classnames"
import { contrastMode } from "css/a11y"

import Link from "components/link/Link"
import Image from "components/media/ImageCLD"
import Video from "components/media/VideoCLD"
import Heading from "components/text/Heading"
import VideoLauncher from "components/video-launcher/VideoLauncher"
import { waTriggerEvent } from "../analytics/DigitalDataLayer"

const Root = styled.aside`
  align-items: center;
  display: grid;
  position: relative;

  > * {
    grid-area: 1/-1;
  }

  img {
    display: block;
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`

const Content = styled.div`
  ${fullGrid}
  position: relative;
  text-align: center;
  word-break: auto-phrase; // chrome-only, slightly nicer line-breaks
  z-index: 0; // needed for contast mode

  > .${HeadingCN} {
    margin-block-end: 2.5rem;

    ${getMediaQuery("m")} {
      margin-block-end: 1.875rem;
    }
  }

  h2.${HeadingCN} {
    padding-bottom: 0;
  }

  .${HeadingCN} {
    grid-column: main;

    ${getMediaQuery("m")} {
      grid-column: col 4 / span 6;
    }
  }
  hgroup,
  h2,
  h3,
  p {
    position: relative;
    ${contrastMode}
  }
`

const Links = styled.ul`
  display: flex;
  flex-wrap: wrap;
  grid-column: main;
  justify-content: center;

  ${getMediaQuery("m")} {
    grid-column: col 3 / span 8;
  }
`

const Button = styled(VideoLauncher)`
  ${buttonText}
`

const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.3);
  grid-area: 1/-1;
  height: 100%;
  position: relative;
  width: 100%;
`

export default function VideoPlayerHowTo(props) {
  const {
    className,
    download_link_cld: { label, aria_label, external },
    heading,
    poster,
    video_player_cld,
  } = props

  const videoProps = poster?.[0]?.video_cld ?? poster?.[1]?.video_cld
  const imageProps = poster?.[0]?.image_cld ?? poster?.[1]?.image_cld

  const console = useConsole()
  console.log(props)

  const triggerEvent = () => {
    waTriggerEvent({
      eventName: "download",
      eventType: "Click",
      products: [
        {
          productCategory: window.location.pathname?.split("/")[2],
          //productID: rmc,
          productQuantity: "1",
        },
      ],
      downloadInfo: {
        fileName: external,
        type: "userguide",
        position: "features family page",
        size: "",
      },
    })
  }

  console.verbose("VideoPlayerHowTo(%o)", props)
  return (
    <Root className={`${className} dark-theme`}>
      {videoProps && <Video autoPlay noButton {...videoProps} sizes='100vw' />}
      {imageProps && <Image {...imageProps} sizes='100vw' />}
      <Overlay />
      <Content>
        <Heading {...heading} />
        <Links>
          {!!video_player_cld?.sources.length && (
            <li>
              <Button video_player_cld={video_player_cld} icon='play' />
            </li>
          )}
          <li>
            <Link className='text' aria-label={aria_label} external={external} icon='download' onClick={triggerEvent}>
              {label}
            </Link>
          </li>
        </Links>
      </Content>
    </Root>
  )
}
